import React from 'react';
import PropTypes from 'prop-types';
import cNames from 'classnames';

function Error(_ref) {
  var id = _ref.id,
      classNames = _ref.classNames,
      error = _ref.error;
  var cssClass = cNames('tds-form__error ', classNames);
  return error ? /*#__PURE__*/React.createElement("p", {
    id: id,
    className: cssClass
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon tds-form__error-icon"
  }), error) : null;
}

Error.propTypes = {
  classNames: PropTypes.string,
  id: PropTypes.string,
  error: PropTypes.node
};
Error.defaultProps = {
  id: null,
  classNames: '',
  error: ''
};
export default Error;